<div class="my-4 flex align-items-center">
    <div>
        <input
        type="file"
        (change)="fileChangeEvent($event)"
        id="file"
        style="display: none"
      />
      <label for="file" class="label"> Scegli un file @if(isFromTravel){PDF}@else{excel} </label>
    </div>

    <div>
        @if(!file && loading){
            <small class="ml-3">Il file non è stato caricato correttamente.</small>
            }@else if(file && !loading){
            <!-- <small class="ml-3">File caricato.</small> -->
            <div class="ml-3 flex align-items-center gap-2">
                @if(isFromTravel){
                    <img src="/assets/imgs/pdf.png" height="32">
                }@else {
                    <img src="src/assets/imgs/file.png" height="32">
                }
                <div class="flex flex-column gap-1">
                    <small>{{file.name}}</small>
                    <small class="grey-text">{{file.size | bytes}}</small>
                </div>
           </div>
            }@else {
              <small class="ml-3"></small>
            }
    </div>

</div>

<div class="modal-footer flex justify-content-between">
  <div class="w-full">
    <p-button
      label="Annulla"
      size="small"
      (click)="close()"
      [outlined]="true"
    ></p-button>
  </div>
  <div class="w-full ml-3">
    <p-button
      label="Salva"
      size="small"
      (click)="save()"
      styleClass="slide-o"
    ></p-button>
  </div>
</div>
